import React from 'react'
import { Link } from 'react-router-dom';
import { Container } from './styles'


const Card = ({
  children,
  onClick,
  isSelected,
  to,
  variant = 'primary',
  ...props
}) => {

  const isClickeable = !!onClick;

  const handleClick = () => {
    if (isClickeable) onClick()
  }

  if (!!to) {
    return (
      <Link to={to}>
        <Container props={props} $variant={variant}>
          {children}
        </Container>
      </Link>
    )
  }

  return (
    <Container
      onClick={handleClick}
      $isClickeable={isClickeable}
      $isSelected={isSelected}
      $variant={variant}
      props={props}
    >
      {children}
    </Container>
  )
}

export default Card